import { useMemo } from "react"
import { DrillDownTable } from "../../widgets"
import { getTaskColumns, mapTaskToRow } from "./helpers"
import { DictStatus } from "@pma/types"

export function KpiDrillDownContent({
  tasks,
  category,
  statuses,
  translate,
  projectsListRaw,
}: {
  tasks: any[]
  category: "open" | "completed" | "canceled" | "all"
  statuses: DictStatus[]
  translate: (key: string) => string
  projectsListRaw: any[]
}) {
  const rows = useMemo(() => {
    const mapped = tasks.map((t) => mapTaskToRow(t, statuses, projectsListRaw))
    if (category === "all") return mapped
    return mapped.filter((r) => r.statusCategory === category)
  }, [tasks, category, statuses, projectsListRaw])

  const columns = useMemo(() => getTaskColumns(translate, statuses), [translate, statuses])

  if (!rows.length)
    return (
      <p className='py-8 text-center text-sm text-muted-foreground'>
        {translate("No tasks found")}
      </p>
    )
  return <DrillDownTable columns={columns} data={rows} />
}
